import PropTypes from "prop-types";
import { productShape } from "app/utils/propTypes";
import { MerchandisingCard } from "../merchandising/MerchandisingCard";
import ProductCard from "app/pages/.shared/ProductCard/ProductCard";
import { LISTING_ITEM_TYPES } from "app/constants";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";

const ListingItemCard = ({ product = {}, resolution, hideMerchandising }) => {
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	if (product.type === LISTING_ITEM_TYPES.PRODUCT) {
		return <ProductCard resolution={resolution} product={product} isMobile={isMobile} />;
	} else if (!hideMerchandising) {
		return <MerchandisingCard product={product} resolution={resolution} />;
	}
	return false;
};

ListingItemCard.propTypes = {
	product: productShape,
	resolution: PropTypes.string,
	hideMerchandising: PropTypes.bool,
};

export default ListingItemCard;
